import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Icon} from '@udemy/icons';
import {Link} from '@udemy/react-core-components';

import styles from './hero-certificate-card.module.less';

export interface HeroCertificateCardProps {
    title: string;
    completedDate?: string;
    certificateUrl?: string;
}

export const HeroCertificateCard: React.FC<HeroCertificateCardProps> = ({
    title,
    completedDate,
    certificateUrl,
}) => {
    const {gettext} = useI18n();

    return (
        <div className={styles['certificate-wrapper']}>
            <div className={styles['completed-badge']}>
                <div className={styles['certificate-icon-container']}>
                    <Icon glyph="certificate" color="inherit" label={false} size="medium" />
                </div>
                <span className="ud-text-md ud-text-bold">{gettext('Certificate completed!')}</span>
            </div>

            <div className={styles['certificate-card']}>
                <div className={styles['icon-casing']}>
                    <Icon glyph="google" size="xlarge" label={false} />
                </div>

                <div className={styles['certificate-info']}>
                    <h3 className={classNames('ud-heading-xl', styles['certificate-title'])}>
                        {title}
                    </h3>
                    {completedDate && (
                        <p className={styles['completed-date']}>
                            {gettext('Completed on')} {completedDate}
                        </p>
                    )}
                </div>
            </div>

            {certificateUrl && (
                <Link
                    to={certificateUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classNames(
                        'ud-btn',
                        'ud-btn-large',
                        'ud-btn-primary',
                        styles['cta-button'],
                    )}
                >
                    {gettext('View certificate')}
                </Link>
            )}
        </div>
    );
};
